import { useRef, useState, useImperativeHandle, forwardRef } from 'react'
import { useDialog } from '../DialogProvider'
import { useLang } from '../LangProvider'
import { useAuth } from '../AuthProvider'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Logout = forwardRef(( props, ref ) => {

  useImperativeHandle(ref, () => ({
    openDialog() {
      handleClose()
      //console.log("logout dialog opened from provider")
      handleOpenDialog()
    }
  }) )

  const [dialogState,setDialogState] = useState(false)
  const closeDialog = useDialog()
  const dialogRef = useRef(null)
  const {lang} = useLang()
  const {auth, setAuth} = useAuth()

  function handleClose(e = undefined){
    if (e !== undefined && e.key !== "Escape") return null
    dialogRef.current.setAttribute("open", false)
    dialogRef.current.close()
    setDialogState(false)
    closeDialog('')
  }

  function handleOpenDialog(){
    setDialogState(true)
    dialogRef.current.removeAttribute("open");
    dialogRef.current.showModal();
  }

  function handleLogout(){
    toast.success((lang['toast logged out'] + auth.username),{
      position: "top-right",
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
      containerId:"app"
    })
    localStorage.setItem('token', 'null')
    localStorage.setItem('timestamp', 0)
    setAuth({
      token:null,
      username:'',
      timesamp:0,
      isAuth:false
    })
    handleClose()
    //window.location.reload(false)
  }

  return<>
    <dialog className={"dialog-logout" + (!dialogState ? ' hidden' : '')}
            open={dialogState} ref={dialogRef} 
            onKeyDown={e => handleClose(e)}>
      <h3>Log out?</h3>
      <button className="button-teal" onClick={() => handleClose()}>{lang['dialog cancel']}</button>
      <button className="button-red" onClick={() => handleLogout()}>{lang['dialog logout']}</button>

      <ToastContainer enableMultiContainer containerId={'dialog-logout'}/>

    </dialog>
  </>
})

export default Logout